export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const swedishLicensePlateRegex = /^[A-Z]{0,3}\d{0,2}[A-Z0-9]?$/;

// The Norwegian license plate format for cars and trucks is two letters followed by up to five digits, while for other
// vehicles (e.g. motorcycles) is two letters followed by up to four digits.
// Source: https://www.vegvesen.no/en/vehicles/own-and-maintain/number-plates/number-plate-series/?lang=en
export const norwegianLicensePlateCarsAndTrucksRegex = /^[A-Z]{2}[0-9]{0,5}$/;
export const norwegianLicensePlateOtherVehiclesRegex = /^[A-Z]{2}[0-9]{0,4}$/;
export const partialNorwegianLicensePlateRegex = /^[A-Z]{0,2}$/;

export const dateOfBirthRegex = /^(0[1-9]|[12][0-9]|3[01])[-/.](0[1-9]|1[012])[-/.](19|20)\d\d$/;

export const numericRegex = /^\d+$/;
